export const GET_DEVICES_REQUEST = "GET_DEVICES_REQUEST";
export const GET_DEVICES_SUCCESS = "GET_DEVICES_SUCCESS";
export const GET_DEVICES_FAILURE = "GET_DEVICES_FAILURE";

export const GET_TYPING_DEVICES_REQUEST = "GET_TYPING_DEVICES_REQUEST";

export const GET_DEVICES_STATUSES_REQUEST = "GET_DEVICES_STATUSES_REQUEST";
export const GET_DEVICES_STATUSES_SUCCESS = "GET_DEVICES_STATUSES_SUCCESS";
export const GET_DEVICES_STATUSES_FAILURE = "GET_DEVICES_STATUSES_FAILURE";

export const GET_DEVICES_SUBSTATUSES_REQUEST = "GET_DEVICES_SUBSTATUSES_REQUEST";
export const GET_DEVICES_SUBSTATUSES_SUCCESS = "GET_DEVICES_SUBSTATUSES_SUCCESS";
export const GET_DEVICES_SUBSTATUSES_FAILURE = "GET_DEVICES_SUBSTATUSES_FAILURE";

export const GET_HISTORY_DEVICES_REQUEST = "GET_HISTORY_DEVICES_REQUEST";
export const GET_HISTORY_DEVICES_SUCCESS = "GET_HISTORY_DEVICES_SUCCESS";
export const GET_HISTORY_DEVICES_FAILURE = "GET_HISTORY_DEVICES_FAILURE";

export const SUBMIT_DEVICES_BATCH_REQUEST = "SUBMIT_DEVICES_BATCH_REQUEST";
export const SUBMIT_DEVICES_BATCH_SUCCESS = "SUBMIT_DEVICES_BATCH_SUCCESS";
export const SUBMIT_DEVICES_BATCH_FAILURE = "SUBMIT_DEVICES_BATCH_FAILURE";

export const SUBMIT_DEVICES_VALIDATE_BATCH_REQUEST = "SUBMIT_DEVICES_VALIDATE_BATCH_REQUEST";
export const SUBMIT_DEVICES_VALIDATE_BATCH_SUCCESS = "SUBMIT_DEVICES_VALIDATE_BATCH_SUCCESS";
export const SUBMIT_DEVICES_VALIDATE_BATCH_FAILURE = "SUBMIT_DEVICES_VALIDATE_BATCH_FAILURE";
export const CLEAN_VALIDATED_DEVICES = "CLEAN_VALIDATED_DEVICES";

export const SUBMIT_DEVICES_REQUEST = "SUBMIT_DEVICES_REQUEST";
export const SUBMIT_DEVICES_SUCCESS = "SUBMIT_DEVICES_SUCCESS";
export const SUBMIT_DEVICES_FAILURE = "SUBMIT_DEVICES_FAILURE";

export const SUBMIT_DEVICES_STATUSES_REQUEST = "SUBMIT_DEVICES_STATUSES_REQUEST";
export const SUBMIT_DEVICES_STATUSES_SUCCESS = "SUBMIT_DEVICES_STATUSES_SUCCESS";
export const SUBMIT_DEVICES_STATUSES_FAILURE = "SUBMIT_DEVICES_STATUSES_FAILURE";

export const SET_STATE_DEVICES = "SET_STATE_DEVICES";

export const SET_DEVICES_SELECTED = "SET_DEVICES_SELECTED";

export const GET_EXPORT_DEVICES_REQUEST = "GET_EXPORT_DEVICES_REQUEST";
export const GET_EXPORT_DEVICES_SUCCESS = "GET_EXPORT_DEVICES_SUCCESS";
export const GET_EXPORT_DEVICES_FAILURE = "GET_EXPORT_DEVICES_FAILURE";

export const CLOSE_PING_EVENT_EXPORT_DEVICES = "CLOSE_PING_EVENT_EXPORT_DEVICES";

export const PATCH_DEVICES_REQUEST = "PATCH_DEVICES_REQUEST";
export const PATCH_DEVICES_SUCCESS = "PATCH_DEVICES_SUCCESS";
export const PATCH_DEVICES_FAILURE = "PATCH_DEVICES_FAILURE";

export const getDevicesRequest = (filters = {}) => ({
    type: GET_DEVICES_REQUEST,
    payload: {
        filters
    }
});

export const getDevicesSuccess = (devices, total, replace = false) => ({
    type: GET_DEVICES_SUCCESS,
    payload: {
        devices,
        total,
        replace
    }
});

export const getDevicesFailure = err => ({
    type: GET_DEVICES_FAILURE,
    error: err
});

export const getTypingDevicesRequest = (filters = {}) => ({
    type: GET_TYPING_DEVICES_REQUEST,
    payload: {
        filters
    }
});

export const getDevicesStatusesRequest = (filters = {}) => ({
    type: GET_DEVICES_STATUSES_REQUEST,
    payload: {
        filters
    }
});

export const getDevicesStatusesSuccess = (statuses, total) => ({
    type: GET_DEVICES_STATUSES_SUCCESS,
    payload: {
        statuses
    }
});

export const getDevicesStatusesFailure = err => ({
    type: GET_DEVICES_STATUSES_FAILURE,
    error: err
});

export const patchDevicesRequest = (data) => ({
    type: PATCH_DEVICES_REQUEST,
    payload: {
        device: data 
    }
});

export const patchDevicesSuccess = validations => ({
    type: PATCH_DEVICES_SUCCESS,
    payload: {
        validations
    }
});

export const patchDevicesFailure = err => ({
    type: PATCH_DEVICES_FAILURE,
    error: err
});

export const getDevicesSubstatusesRequest = (filters = {}) => ({
    type: GET_DEVICES_SUBSTATUSES_REQUEST,
    payload: {
        filters
    }
});

export const getDevicesSubstatusesSuccess = (substatuses, total) => ({
    type: GET_DEVICES_SUBSTATUSES_SUCCESS,
    payload: {
        substatuses
    }
});

export const getDevicesSubstatusesFailure = err => ({
    type: GET_DEVICES_SUBSTATUSES_FAILURE,
    error: err
});

export const getHistoryDevicesRequest = (filters = {}) => ({
    type: GET_HISTORY_DEVICES_REQUEST,
    payload: {
        filters
    }
});

export const getHistoryDevicesSuccess = (history, total) => ({
    type: GET_HISTORY_DEVICES_SUCCESS,
    payload: {
        history
    }
});

export const getHistoryDevicesFailure = err => ({
    type: GET_HISTORY_DEVICES_FAILURE,
    error: err
});

export const submitDevicesBatchRequest = (device, options = {}) => ({
    type: SUBMIT_DEVICES_BATCH_REQUEST,
    payload: {
        device,
        options
    }
});

export const submitDevicesBatchSuccess = devices => ({
    type: SUBMIT_DEVICES_BATCH_SUCCESS,
    payload: {
        devices
    }
});

export const submitDevicesBatchFailure = err => ({
    type: SUBMIT_DEVICES_BATCH_FAILURE,
    error: err
});

export const submitDevicesValidateBatchRequest = device => ({
    type: SUBMIT_DEVICES_VALIDATE_BATCH_REQUEST,
    payload: {
        device
    }
});

export const submitDevicesValidateBatchSuccess = validations => ({
    type: SUBMIT_DEVICES_VALIDATE_BATCH_SUCCESS,
    payload: {
        validations
    }
});

export const submitDevicesValidateBatchFailure = err => ({
    type: SUBMIT_DEVICES_VALIDATE_BATCH_FAILURE,
    error: err
});

export const cleanValidatedDevices = () => ({ type: CLEAN_VALIDATED_DEVICES });

export const submitDevicesRequest = device => ({
    type: SUBMIT_DEVICES_REQUEST,
    payload: {
        device
    }
});

export const submitDevicesSuccess = device => ({
    type: SUBMIT_DEVICES_SUCCESS,
    payload: {
        device
    }
});

export const submitDevicesFailure = err => ({
    type: SUBMIT_DEVICES_FAILURE,
    error: err
});

export const submitDevicesStatusesRequest = status => ({
    type: SUBMIT_DEVICES_STATUSES_REQUEST,
    payload: {
        status
    }
});

export const submitDevicesStatusesSuccess = status => ({
    type: SUBMIT_DEVICES_STATUSES_SUCCESS,
    payload: {
        status
    }
});

export const submitDevicesStatusesFailure = err => ({
    type: SUBMIT_DEVICES_STATUSES_FAILURE,
    error: err
});

export const setStateDevices = (payload = {}) => ({
    type: SET_STATE_DEVICES,
    payload: {
        ...payload
    }
});

export const setDeviceSelected = (device = {}) => ({
    type: SET_DEVICES_SELECTED,
    payload: {
        device
    }
});

export const getExportDevicesRequest = (filters) => ({
    type: GET_EXPORT_DEVICES_REQUEST,
    payload: {
        filters
    }
});

export const getExportDevicesSuccess = (fileName) => ({
    type: GET_EXPORT_DEVICES_SUCCESS,
    payload: {
        fileName
    }
});

export const getExportDevicesFailure = () => ({
    type: GET_EXPORT_DEVICES_FAILURE,
    
});

export const closePingEventExportDevices = () => ({
    type: CLOSE_PING_EVENT_EXPORT_DEVICES,
});